import type { IconData } from '../../types';

export const data: IconData = {
  o: '<mask id="a" width="22" height="22" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h22v22H0z"/></mask><g stroke="#43474E" mask="url(#a)"><path fill="#43474E" d="M5 3h6l1 1H4v14h8v1H5l-1-1-1-1V5l1-1 1-1Zm10 15-1 1h-1v-1h2Zm-1-5h3v3l-1 1h-3v-3l1-1Zm5 0v1l-1 1v-2h1Zm-1-2h1v1h-1v-1Z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 4-7 7-3-3"/></g>',
  f: '<mask id="a" width="22" height="22" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h22v22H0z"/></mask><g stroke="#43474E" mask="url(#a)"><path fill="#43474E" d="M5 3h6l1 1H4v14h8v1H5l-1-1-1-1V5l1-1 1-1Zm10 15-1 1h-1v-1h2Zm-1-5h3v3l-1 1h-3v-3l1-1Zm5 0v1l-1 1v-2h1Zm-1-2h1v1h-1v-1Z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 4-7 7-3-3"/></g>',
  vb: '0 0 22 22',
  rao: { fill: 'none' },
  raf: { fill: 'none' },
};

export default data;
